export const MOBILE_REGEX =
    /(([(]?[+]?[(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))[)]??[(]?[0-9]{1,3}[)]?([0-9]{3})([0-9]{3,4})/g;
export const NAME_REGEX = /^[A-Za-z0-9 '-]*$/;
// export const URL_REGEX =
// "^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$";
export const URL_REGEX =
    /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
export const VIMEO_REGEX =
    '/(?:<iframe [^>]*src=")?((?:https?://)?(?:[w]+.)*vimeo.com(?:[/w:]*(?:/videos)?)?/([0-9]+)[^s]*)"?(?:[^>]*></iframe>)?(?:<p>.*</p>)?/g';
export const YOUTUBE_REGEX =
    '/(?:(?:https?://)(?:www)?.?(?:youtu.?be)(?:.com)?/(?:.*[=/])*)([^= &?/\r\n]{8,11})/g';
export const EMAIL_REGEX = /^(?!www\.)(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})(?<!\.co)$/;
export const PASSWORD_REGEX =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
export const STUDENT_NUMBER_REGEX =
    /^(?:\d{6}_\d{6}|\d{6}|\d{5})$/;
export const TABLE_DATE_FORMAT = 'DD MMM YY';
export const FORM_DATE_FORMAT = 'd MMM yy';
export const TABLE_DATE_TIME_FORMAT = 'DD MMM YY, HH:mm';
export const FORM_DATE_TIME_FORMAT = 'dd MMM yyyy, HH:mm';
export const TABLE_TIME_FORMAT = 'HH:mm';
export const FORM_TIME_FORMAT = 'HH:mm';
export const NETSUITE_DATE_TIME_FORMAT = 'DD-MM-YYYY h:mm A';
export const TABLE_ROWS_PER_PAGE = [10, 15, 20, 25, 30, 50, 100];
export const SP_PASS = 'aa*S4571';
export const DATE_FORMAT = 'DD MMM YYYY';
export const AWS_BASE_URL= "https://assessments.myaie.ac/"


export const API_BASE = process.env.REACT_APP_API_BASE;
export const ROOT_URL_AWS = process.env.REACT_APP_ROOT_URL_AWS;
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
export const STUDENT_PORTAL_URL = process.env.REACT_APP_STUDENT_PORTAL_URL;
export const WS_URL = process.env.REACT_APP_WS_URL;
export const APP_LINK = process.env.REACT_APP_APP_LINK;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const downloadURL = process.env.REACT_APP_downloadURL;
export const DOMAIN_COLOR = process.env.REACT_APP_DOMAIN_COLOR;
export const STUDENT_FILE_DOWNLOAD = process.env.REACT_APP_STUDENT_FILE_DOWNLOAD;
export const STUDENT_FILES_DOWNLOAD = process.env.REACT_APP_STUDENT_FILES_DOWNLOAD;
export const UPLOAD_ROOT_PATH = process.env.REACT_APP_UPLOAD_ROOT_PATH;
